exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "floating-action-buttons{display:block;position:fixed;bottom:0;left:0;width:100%;z-index:1000;opacity:1}floating-action-buttons.ng-hide{opacity:0}floating-action-buttons.ng-hide-add,floating-action-buttons.ng-hide-remove{transition:all .5s linear}floating-action-buttons.with-choices{bottom:75px}floating-action-buttons .floating-action-buttons-list .btn[disabled]{opacity:1;background-color:#5aa4dc}floating-action-buttons .floating-action-buttons-list.one-button .btn,floating-action-buttons .floating-action-buttons-list.two-buttons .btn{height:75px;font-size:16px}floating-action-buttons .floating-action-buttons-list.one-button .btn{width:100%}floating-action-buttons .floating-action-buttons-list.two-buttons .btn{width:50%}floating-action-buttons .floating-action-buttons-list .btn.btn-app.btn-primary:focus{color:#fff;background-color:#0072c9;outline:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/floatingActionButtons/floatingActionButtons.scss
// module id = 1014
// module chunks = 0